import { PopoverButton as HeadlessPopoverButton } from "@headlessui/react"
import { ChevronDown } from "lucide-react"
import {
  Button,
  ButtonMode,
  ButtonSize,
} from "shared-web/components/base/control/Button"
import { IconButton } from "shared-web/components/base/control/IconButton"
import { TextButton } from "shared-web/components/base/control/TextButton"

import { PopoverMenuButtonProps, PopoverMenuButtonVariants } from "./types"

function PopoverMenuButton(props: PopoverMenuButtonProps) {
  switch (props.buttonVariant) {
    case PopoverMenuButtonVariants.Icon: {
      const { icon, buttonMode, buttonSize } = props
      return (
        <HeadlessPopoverButton
          as={IconButton}
          icon={icon}
          size={buttonSize}
          mode={buttonMode ?? ButtonMode.Ghost}
        />
      )
    }
    case PopoverMenuButtonVariants.Text: {
      const { buttonTitle } = props
      return (
        <HeadlessPopoverButton
          as={TextButton}
          className="h-6.5 rounded-control w-fit px-2"
        >
          {buttonTitle}
        </HeadlessPopoverButton>
      )
    }
    default: {
      const { buttonMode, buttonSize, buttonLeftIcon, buttonTitle } = props
      return (
        <HeadlessPopoverButton
          as={Button}
          mode={buttonMode ?? ButtonMode.Primary}
          size={buttonSize ?? ButtonSize.Default}
          leftIcon={buttonLeftIcon}
          rightIcon={ChevronDown}
        >
          {buttonTitle}
        </HeadlessPopoverButton>
      )
    }
  }
}

export default PopoverMenuButton
